<template>
	<section class="marketing-section premium-module-section bg-gradient-premium">
		<div class="container">
			<div
				class="display-flex align-items-center justify-content-space-between flex-direction-column-smo gap-300-smo"
			>
				<div class="display-flex flex-direction-column gap-250 col-5-md">
					<div class="text-color-white">
						<h2 class="heading-1 heading-2-smo">Get rewarded for growing with Fundrise</h2>
						<p class="body-xl-md body-lg mt-50"
							>Unlock exclusive benefits when you invest $100,000 or&nbsp;more</p
						>
					</div>
					<div>
						<BaseLink :link="learnMoreLink" classes="button button-gold width-100-smo" />
					</div>
				</div>
				<div class="display-flex flex-direction-column gap-300 col-5-md">
					<div
						v-for="(benefit, i) in premiumBenefits"
						:key="i"
						class="display-flex align-items-center gap-150"
					>
						<BaseSvgIcon :name="benefit.icon" class="premium-icon" height="32" width="32" />
						<div class="display-flex flex-direction-column text-color-white">
							<div class="body-lg font-weight-bold">{{ benefit.heading }}</div>
							<div class="body-md">{{ benefit.description }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
import { Link } from 'types/layout';
import { PremiumBenefit } from 'types/marketing-site';

const learnMoreLink: Link = {
	text: 'Learn more',
	router: 'premium-landing'
};

const premiumBenefits: Array<PremiumBenefit> = [
	{
		icon: 'bank',
		heading: 'Exclusive investments',
		description: 'Access unique and opportunistic offerings'
	},
	{
		icon: 'user-multiple',
		heading: 'White-glove support',
		description: 'Get dedicated, priority service from our expert team'
	},
	{
		icon: 'cash-stack',
		heading: '12-month fee waiver*',
		description: 'Enjoy a year with no advisory fees (0.15%)'
	}
];
</script>
<style lang="scss">
@use '../../styles/constants/colors' as *;

.premium-module-section {
	.button-gold {
		color: token('content-primary');
		background-color: gold(60);
		border-color: gold(60);

		&:hover {
			background-color: gold(70);
		}
	}

	.premium-icon {
		color: gold(70);
	}
}
</style>
